import {formatDisplayDateTime} from '@/dayjs'
import {TKey, useTranslation} from '@/translations/i18n'
import {BugReportIssue, BugReportIssueStateType} from '../../types'
import {StyledCompletedAt, StyledStatus, StyledStatusDot} from './style'

export const ASSIGNEE_VISIBLE_STATE_TYPES: BugReportIssueStateType[] = ['unstarted', 'started', 'completed']

export const RESOLVED_STATE_TYPES: BugReportIssueStateType[] = ['completed', 'canceled']

export const isResolvedIssue = (issue: BugReportIssue) =>
    !!issue.state && RESOLVED_STATE_TYPES.includes(issue.state.type)

export const STATE_TYPE_TRANSLATION_KEY: Record<BugReportIssueStateType, TKey> = {
    triage: 'bug_reporter:status_triage',
    backlog: 'bug_reporter:status_backlog',
    unstarted: 'bug_reporter:status_unstarted',
    started: 'bug_reporter:status_started',
    completed: 'bug_reporter:status_completed',
    canceled: 'bug_reporter:status_canceled'
}

export const hasVisibleAssignee = (issue: BugReportIssue) =>
    !!issue.assignee && !!issue.state && ASSIGNEE_VISIBLE_STATE_TYPES.includes(issue.state.type)

export const IssueStatus = ({issue}: {issue: BugReportIssue}) => {
    const {t} = useTranslation()

    if (!issue.state) return null

    return (
        <StyledStatus>
            <StyledStatusDot $color={issue.state.color} />
            {t(STATE_TYPE_TRANSLATION_KEY[issue.state.type])}
            {issue.state.type === 'completed' && issue.completedAt && (
                <StyledCompletedAt>· {formatDisplayDateTime(issue.completedAt)}</StyledCompletedAt>
            )}
        </StyledStatus>
    )
}
